export function lte(a: number, b: number) {
  return a <= b;
}

export function lt(a: number, b: number) {
  return a < b;
}

export function gte(a: number, b: number) {
  return a >= b;
}

export function gt(a: number, b: number) {
  return a > b;
}
